
const digest = '81ed58333acf6816ded99db701fa3bcdf9c0c00f9acea13b066da02a170c3cf4';
const classes = {"navigation":"_navigation_1t15z_1"};
const css = `._navigation_1t15z_1 {
  border: 0;
  border-bottom: 1px solid #eaedf3;
  padding: 0 0 15px;
  margin-bottom: 10px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  